import { useQuery } from "@tanstack/react-query";
import { getContactByIdRequest, getContactRequest } from "../requests/contact";

export function useContacts({ params }) {
  return useQuery({
    queryKey: ["contact", params],
    queryFn: async () => {
      const res = await getContactRequest({ params });
      return res.data?.data;
    },
  });
}

export function useContactById({ id }) {
  return useQuery({
    queryKey: ["contact", id],
    queryFn: async () => {
      const res = await getContactByIdRequest({
        id,
      });
      return res.data;
    },
  });
}